import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
interface InputProps {
  label: string;
  type?: 'text' | 'email' | 'password';
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}
export function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  className = ''
}: InputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [internalValue, setInternalValue] = useState(value || '');
  const inputType = type === 'password' && showPassword ? 'text' : type;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    onChange?.(newValue);
  };
  return <div className={`${className}`} data-id="element-121">
      <label className="block text-sm font-medium text-[#1f5070] mb-2" data-id="element-122">
        {label}
      </label>
      <div className="relative" data-id="element-123">
        <input type={inputType} placeholder={placeholder} value={internalValue} onChange={handleChange} className="w-full px-4 py-3 border border-[#dee2e6] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3dc7e3] focus:border-transparent transition-all" style={{
        height: '48px'
      }} data-id="element-124" />
        {type === 'password' && <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600" data-id="element-125">
            {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-126" /> : <EyeIcon className="w-5 h-5" data-id="element-127" />}
          </button>}
      </div>
    </div>;
}